<template>
    <div>
        <v-chart :key="symbol_code+':' + echartsTheme" :style="chart_style()" :options="line" :theme="echartsTheme" :notMerge="true" :autoresize="true" @click="handleChartClick" />
    </div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import {
		request_zzquant
	} from "network/request.js"

    
	
	const dataZoomData = {
		"start": 60,
		"end": 100
	}

	export default {
		props: {
			title: String,
			subText: String,
			symbol_code: String,
			zoom_start:{type:Number,default:60},
			chart_heigh:{type:String,default:'600px'},
			chart_width:{type:String,default:'100%'},
			highlightDate: String,
            showLhb: { type: Boolean, default: false },
            traderName: { type: String, default: '' },
            kline_url: { type: String, default: '' },
		},
	components: {
		'v-chart': ECharts
	},
		watch:{
			symbol_code:'refresh',
			highlightDate: 'updateHighlight',
            traderName: 'refresh'
		},
data() {
    return {
        theme:'light',
        colorblind: false,
        internalHighlightDate: null,
        lhbData: [],
        cancelTokenSource: null,
        line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: '1%',
						// textAlign:'right',
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					legend: {
				show:true,
				top: 10,
				left: 'center',
				data: ['K', 'MA5', 'Volume', 'LHB Buy', 'LHB Sell'],
				textStyle: {
					color: '#999999'
				},
				selected: {
					'MA5': true,
					'MA25': true,
					'K': true,
					'Volume': true,
					'v5': true,
					'B2': true,
					'v60': true,
					'B1': true,
					'B3': true,
                    'LHB Buy': true,
                    'LHB Sell': true
				}
			},
					visualMap: {
						show: false,
						seriesIndex: 3,
						dimension: 2,
						pieces: [{
							value: 1,
							color: '#0072B2'
						}, {
							value: -1,
							color: '#E69F00'
						}]
					},
					grid: [{
							left: '10%',
							right: '8%',
							height: '50%'
						},
						{
							left: '10%',
							right: '8%',
							top: '63%',
							height: '25%'
						}
					],
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax'
						}
					],
					yAxis: [{
							scale: true,
							offset: 2,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							position: 'left',
							min: 'dataMin',
							max: 'dataMax',
						},
						{
							scale: true,
							offset: 2,
							position: 'right',
							gridIndex: 1,
							splitNumber: 2,
							axisLabel: {
								show: false
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
						}, {
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							// axisLine: {
							// 	lineStyle: {
							// 		color: '#666666',
							// 		width: 1
							// 	}
							// },
							splitLine: false,
							position: 'right',

						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: dataZoomData.end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},
	computed:{
		echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null }
	},
mounted() {
	// console.log("mounted");
	this.refresh();
	{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }
	{ const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }
	window.addEventListener('site-theme-changed', this.onThemeChanged)
	window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
	window.addEventListener('keydown', this.onKeydown)
},
		beforeDestroy(){ window.removeEventListener('site-theme-changed', this.onThemeChanged); window.removeEventListener('site-colorblind-changed', this.onColorblindChanged); window.removeEventListener('keydown', this.onKeydown) },
		created(){
			this.onThemeChanged = (e)=>{ const t = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = t }
			this.onColorblindChanged = (e)=>{ const v = e && e.detail && typeof e.detail.colorblind!=='undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() }
			this.onKeydown = (e)=>{ const k = e && e.key ? e.key : ''; if(k==='ArrowLeft' || k==='Left'){ e.preventDefault && e.preventDefault(); this.moveHighlight(-1) } else if(k==='ArrowRight' || k==='Right'){ e.preventDefault && e.preventDefault(); this.moveHighlight(1) } }
		},
		methods: {
			chart_style(){
				return {
					width: this.chart_width,
					height: this.chart_heigh,
				}
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data.values[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			calculateVolumeMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.vols.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data.vols[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(0));
				}
				return result;
			},
            refresh(date) {
                // Cancel previous request
                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel('Operation canceled by the user.');
                }
                this.cancelTokenSource = axios.CancelToken.source();

                this.resetChart();
                this.line['title']  = {
                    text: this.title,
                    subtext: this.subText,
                    // left: 0
					textStyle: {
						color: '#999999'
					},
					subtextStyle: {
						color: '#666666'
					}
                };
                if(this.symbol_code && this.symbol_code.length!=6){
                    return
                }
                const effDate = this.internalHighlightDate || this.highlightDate;
                date = effDate ? effDate : date;
                if (!this.symbol_code){
                    return
                }
                const reqUrl = this.kline_url ? this.kline_url : ('/v3/open/kline/d/' + this.symbol_code);
				axios.all([
                        request_zzquant({
                            'url': reqUrl,
                            cancelToken: this.cancelTokenSource.token
                        }),
                        this.showLhb ? request_zzquant({
                            'url': 'market/lhb/stock/history',
                            'method': 'get',
                            'params': {
                                'stock_code': this.symbol_code,
                                'trader_name': this.traderName
                            },
                            cancelToken: this.cancelTokenSource.token
                        }) : Promise.resolve({ data: { code: 0, data: [] } })
					])
			.then(axios.spread((resp1, resp2) => {
						// console.log(resp1);
						// console.log(resp2);
						let splitDataItem = this.splitData(resp1['data']['data'], date);
                        let lhbList = (resp2 && resp2['data'] && (resp2['data']['code'] === 0 || resp2['data']['code'] === 20000)) ? resp2['data']['data'] : [];
                        this.lhbData = lhbList;

						// 更新title
						// let symbol_name = resp1['data']['data']['name'];
						this.line['title']  = {
							text: this.title,
							// subtext: symbol_name,
							textStyle: {
								color: '#999999'
							},
							subtextStyle: {
								color: '#666666'
							}
						};
					let series_data = []
					const upColor = this.colorblind ? '#E69F00' : '#ec0000'
					const downColor = this.colorblind ? '#0072B2' : '#00da3c'
						series_data.push({
							name: 'MA5',
							data: this.calculateMA(5, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								}
							},
							symbol: 'circle',
						});
						
						series_data.push({
							name: 'MA25',
							data: this.calculateMA(25, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
									color: '#9932CC' // 紫色
								}
							},
							symbol: 'circle',
						});

						series_data.push({
							name: 'K',
							data: splitDataItem.values,
							type: 'candlestick',
							itemStyle: {
								normal: {
								color: upColor,
								color0: downColor,
								borderColor: upColor,
								borderColor0: downColor,
								borderWidth: 1.5
							}
						},

						});

						series_data.push({
							name: 'Volume',
							data: splitDataItem.vols,
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});
						
						// 添加5日成交量均线
						series_data.push({
							name: 'v5',
							data: this.calculateVolumeMA(5, splitDataItem),
							type: 'line',
							xAxisIndex: 1,
							yAxisIndex: 1,
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: '#FF8C00' // 深橙色
								}
							},
						});
						
						// 添加60日成交量均线
						series_data.push({
							name: 'v60',
							data: this.calculateVolumeMA(60, splitDataItem),
							type: 'line',
							xAxisIndex: 1,
							yAxisIndex: 1,
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: '#4169E1' // 皇家蓝
								}
							},
						});

						// 涨停位
						series_data.push({
							name: 'today_uplimit',
							data: splitDataItem.values_close_last,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								color: upColor
							},
						},
							symbol: 'circle',
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
									type: 'max',
									name: '当日涨停',
									symbol: 'circle',
								}, ]
							}
						});

                        // 次日涨停位
                        series_data.push({
                            name: 'next_uplimit',
                            data: splitDataItem.values_next_uplimit,
                            type: 'line',
                            showSymbol: false,
                            lineStyle: {
                                normal: {
                                    width: 1,
                                    opacity: 0.4,
                                    color: 'gray'
                                },
                            },
                            symbol: 'circle',
                            markLine: {
                                symbol:'none',//去掉箭头
                                data: [{
                                    type: 'max',
                                    name: '次日涨停',
                                    symbol: 'circle',
                                }, ]
                            }
                        });
						
						// 添加LHB标记
                        if (this.showLhb && this.lhbData && this.lhbData.length > 0) {
                            let lhbBuyData = [];
                            let lhbSellData = [];
                            
                            // Map LHB data by date for faster lookup
                            const lhbMap = {};
                            this.lhbData.forEach(item => {
                                // API returns date as 'YYYY-MM-DD'
                                // K-line categoryData is 'YYYYMMDD'
                                const dateKey = item.date.replace(/-/g, '');
                                lhbMap[dateKey] = item;
                            });

                            for (let i = 0; i < splitDataItem.categoryData.length; i++) {
                                const dateKey = splitDataItem.categoryData[i];
                                const lhbItem = lhbMap[dateKey];
                                
                                if (lhbItem) {
                                    // B point: Buy > 0
                                    if (lhbItem.buy_in > 0) {
                                        lhbBuyData.push([
                                            dateKey,
                                            this.computeMarkerY(splitDataItem, i)
                                        ]);
                                    } 
                                    // S point: Buy < 0 (Net Sell)
                                    else if (lhbItem.buy_in < 0) {
                                        lhbSellData.push([
                                            dateKey,
                                            this.computeMarkerY(splitDataItem, i)
                                        ]);
                                    }
                                }
                            }

                            if (lhbBuyData.length > 0) {
                                series_data.push({
                                    name: 'LHB Buy',
                                    type: 'scatter',
                                    data: lhbBuyData,
                                    symbol: 'circle', // Using circle for cleaner look, or 'arrow'
                                    symbolSize: 12,
                                    symbolOffset: [0, -10],
                                    itemStyle: {
                                        color: '#d9534f' // Bootstrap danger red
                                    },
                                    label: {
                                        show: true,
                                        formatter: this.traderName ? 'B' : '榜',
                                        color: '#fff',
                                        fontSize: 8,
                                        position: 'inside'
                                    },
                                    z: 100
                                });
                            }

                            if (lhbSellData.length > 0) {
                                series_data.push({
                                    name: 'LHB Sell',
                                    type: 'scatter',
                                    data: lhbSellData,
                                    symbol: 'circle',
                                    symbolSize: 12,
                                    symbolOffset: [0, -10],
                                    itemStyle: {
                                        color: '#28a745' // Bootstrap success green
                                    },
                                    label: {
                                        show: true,
                                        formatter: this.traderName ? 'S' : '榜',
                                        color: '#fff',
                                        fontSize: 8,
                                        position: 'inside'
                                    },
                                    z: 100
                                });
                            }
                        }

						// 添加B点标记
						let bPointData = [];
						// 只查找第一个符合条件的B点
						for (let i = 13; i < splitDataItem.categoryData.length; i++) {
							if (this.checkBPointCondition(splitDataItem, i)) {
								// 只添加第一个B点数据
								bPointData.push([
									splitDataItem.categoryData[i], 
									this.computeMarkerY(splitDataItem, i)
								]);
								i += 10; // 找到一个后跳过后续10个点位
							}
						}
						
						// 只有当有B点数据时才添加到series_data
						if (bPointData.length > 0) {
								let bPointMarker = {
									name: 'B1',
									type: 'scatter',
									data: bPointData,
									symbol: 'arrow',
									symbolSize: 7,
									symbolOffset: [0, -6],
									itemStyle: {
										color: 'rgba(255, 0, 0, 0.6)'
									},
									label: {
										show: true,
										formatter: '',
										position: 'top',
										offset: [0, -2]
									}
								};
							series_data.push(bPointMarker);
							// console.log('添加了B点标记，数量:', bPointData.length);
						}
						
						// 添加B2点标记
						let b2PointData = [];
						for (let i = 13; i < splitDataItem.categoryData.length; i++) {							
							if (this.checkB2PointCondition(splitDataItem, i)) {
								// 添加B2点数据
								b2PointData.push([
									splitDataItem.categoryData[i], 
									this.computeMarkerY(splitDataItem, i)
								]);
								i += 10; // 找到一个后跳过后续10个点位
								// console.log('添加B2点，日期:', splitDataItem.categoryData[i]);
							}
						}
						
						// 只有当有B2点数据时才添加到series_data
						if (b2PointData.length > 0) {
								let b2PointMarker = {
									name: 'B2',
									type: 'scatter',
									data: b2PointData,
									symbol: 'diamond',
									symbolSize: 7,
									symbolOffset: [0, -6],
									itemStyle: {
										color: 'rgba(128, 0, 128, 0.7)'
									},
									label: {
										show: true,
										formatter: '',
										position: 'top',
										offset: [0, -2]
									}
								};
							series_data.push(b2PointMarker);
							// console.log('添加了B2点标记，数量:', b2PointData.length);
						}
						
						// 添加B3点标记
						let b3PointData = [];
						// 查找符合条件的B3点，找到一个后跳过后续10个点位再继续判断
						for (let i = 15; i < splitDataItem.categoryData.length; i++) {
							if (this.checkB3PointCondition(splitDataItem, i)) {
								// 添加B3点数据
								b3PointData.push([
									splitDataItem.categoryData[i], 
									this.computeMarkerY(splitDataItem, i)
								]);
								i += 10; // 找到一个后跳过后续10个点位
								console.log('找到B3点，跳过后续10个点位，下一个检查点位:', i);
							}
						}
						
						// 只有当有B3点数据时才添加到series_data
						if (b3PointData.length > 0) {
								let b3PointMarker = {
									name: 'B3',
									type: 'scatter',
									data: b3PointData,
									symbol: 'triangle',
									symbolSize: 7,
									symbolOffset: [0, -6],
									itemStyle: {
										color: 'rgba(75, 0, 130, 0.7)'
									},
									label: {
										show: true,
										formatter: '',
										position: 'top',
										offset: [0, -2]
									}
								};
							series_data.push(b3PointMarker);
							// console.log('添加了B3点标记，数量:', b3PointData.length);
						}
						
                        const eff = this.internalHighlightDate || this.highlightDate;
                        if (eff) {
                            let xHighLightDate = eff.replaceAll("-", "")
                            let highlightIndex = splitDataItem.categoryData.indexOf(xHighLightDate);
                            // console.log(xHighLightDate)
                            if (highlightIndex !== -1) {
							let highlightSeriesMarkLine = {
								name: 'Highlight MarkLine',
								type: 'line',
								markLine: {
									silent: true,
									data: [{
										name: 'highlight line',
										xAxis: xHighLightDate,
										lineStyle: {
											normal: {
												width: 2,
												opacity: 0.6,
												color: 'rgba(135, 206, 235)'
											},
										}
									}]
								}
							};
							series_data.push(highlightSeriesMarkLine);
							
							// Create a new series for the highlight point on the Volume chart
							let highlightSeriesVolume = {
								name: 'Highlight Volume',
								type: 'scatter',
								symbol: 'pin',
								symbolSize: 15,
								xAxisIndex: 1,
								yAxisIndex: 1,
								data: [
									[xHighLightDate, splitDataItem.vols[highlightIndex][1]]
								] // Use the volume for the y value
							};
							series_data.push(highlightSeriesVolume);

							const totalPoints = splitDataItem.categoryData.length;
							if (totalPoints > 0) {
								let startIdx = highlightIndex;
								let endIdx = highlightIndex;
								if (highlightIndex > 0 && highlightIndex < totalPoints - 1) {
									startIdx = highlightIndex - 1;
									endIdx = highlightIndex + 1;
								} else if (highlightIndex === 0 && totalPoints > 1) {
									startIdx = highlightIndex;
									endIdx = highlightIndex + 1;
								} else if (highlightIndex === totalPoints - 1 && totalPoints > 1) {
									startIdx = highlightIndex - 1;
									endIdx = highlightIndex;
								}
								const startDate = splitDataItem.categoryData[startIdx];
								const endDate = splitDataItem.categoryData[endIdx];
								const areaData = [[{ xAxis: startDate }, { xAxis: endDate }]];
								const areaStyle = { color: 'rgba(135, 206, 235, 0.15)' };
								const kSeries = series_data.find(s => s.name === 'K' && s.type === 'candlestick');
								if (kSeries) {
									kSeries.markArea = { silent: true, itemStyle: areaStyle, data: areaData };
								}
								const volSeries = series_data.find(s => s.name === 'Volume' && s.type === 'bar');
								if (volSeries) {
									volSeries.markArea = { silent: true, itemStyle: areaStyle, data: areaData };
								}
							}

							const dz = Array.isArray(this.line.dataZoom) ? this.line.dataZoom[0] : null;
							if (dz && typeof dz.start === 'number' && typeof dz.end === 'number') {
								const total = splitDataItem.categoryData.length;
								const datePct = total > 0 ? (highlightIndex / total) * 100 : 0;
								const currStart = dz.start;
								const currEnd = dz.end;
								const inView = datePct >= currStart && datePct <= currEnd;
								if (!inView) {
									const range = currEnd - currStart;
									let newStart = datePct - range * 0.3;
									if (newStart < 0) newStart = 0;
									if (newStart + range > 100) newStart = 100 - range;
									dz.start = Math.max(0, Math.min(100, newStart));
									dz.end = Math.max(0, Math.min(100, dz.start + range));
								}
							}
						}
					}
						
						
                        if (Array.isArray(this.line.xAxis) && this.line.xAxis.length >= 2) {
                            this.line.xAxis[0].data = splitDataItem.categoryData
                            this.line.xAxis[1].data = splitDataItem.categoryData
                        }
                        this._klineSplit = splitDataItem
                        this.line.tooltip.formatter = (params) => {
                            const p = Array.isArray(params) ? params[0] : params
                            const idx = p && typeof p.dataIndex === 'number' ? p.dataIndex : 0
                            const dateRaw = (p && (p.name || p.axisValue)) || ''
                            const dateStr = dateRaw.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
                            const wkMap = ['周日','周一','周二','周三','周四','周五','周六']
                            const wk = dateStr ? wkMap[new Date(dateStr).getDay()] : ''
                            const yv = this._klineSplit && this._klineSplit.values && this._klineSplit.values[idx] ? this._klineSplit.values[idx] : null
                            if (!yv) return dateStr
                            const open = yv[0]
                            const close = yv[1]
                            const low = yv[2]
                            const high = yv[3]
                            const preclose = this._klineSplit.values_preclose && this._klineSplit.values_preclose[idx]
                            const volume = (this._klineSplit.vols && this._klineSplit.vols[idx] && this._klineSplit.vols[idx][1]) || ''
                            const turnover = this._klineSplit.values_turnover && this._klineSplit.values_turnover[idx]
                            const turnoverPct = (turnover !== undefined && turnover !== '-') 
                                ? (Number(turnover) / 100).toFixed(2) 
                                : ''
                            const openPct = preclose ? (((open - preclose) / preclose) * 100).toFixed(2) : ''
                            const closePct = preclose ? (((close - preclose) / preclose) * 100).toFixed(2) : ''
                            const amplitudePct = preclose ? (((high - low) / preclose) * 100).toFixed(2) : ''
                            const volText = typeof volume === 'number' ? volume.toLocaleString() : volume
                            const openSign = preclose && open - preclose >= 0 ? '+' : ''
                            const closeSign = preclose && close - preclose >= 0 ? '+' : ''
                            return [
                                `${dateStr} ${wk}`,
                                `涨幅: ${closePct ? (closeSign + closePct + '%') : '-'}`,
                                `开盘: ${openPct ? (openSign + openPct + '%') : '-'}`,
                                `振幅: ${amplitudePct ? (amplitudePct + '%') : '-'}`,
                                `换手: ${turnoverPct !== '' ? (turnoverPct + '%') : '-'}`,
                                `开盘价: ${open}`,
                                `收盘价: ${close}`,
                                `最高价: ${high}`,
                                `最低价: ${low}`,
                                `成交量: ${volText}`
                            ].join('<br/>')
                        }
					this.line['series'] = series_data
					if (this.line && this.line.visualMap && Array.isArray(this.line.visualMap.pieces)) {
						this.line.visualMap.pieces[0].color = downColor
						this.line.visualMap.pieces[1].color = upColor
					}
			}))
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else {
                    console.log(err);
                }
            })
        },
        resetChart(){
            this.line['series'] = []
        },
			splitData(rawData) {
				// console.log(111)
				// console.log(rawData);
				let[categoryData, values, values_close, vols, values_close_last, values_next_uplimit, values_preclose, values_turnover] = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]]
				let [x,y,vol] = [rawData['x'],rawData['y'],rawData['vol']]
				let turnover = rawData['turnover'] || []
				let idx_start = 0;
				let idx_end = x.length
				// console.log(date);
				// if (date) {
				// 	date = date.replace(/-/g, '');
				// 	let idx_date = x.indexOf(date);
				// 	idx_end = idx_date + 2;
				// 	if (idx_end > x.length) {
				// 		idx_end = x.length
				// 	}
				// }
				// console.log(idx_end,x.length);
				for (let i = idx_start; i < idx_end; i++) {
					// console.log(i,idx_end,x[i]);
					categoryData.push(x[i]);
					values.push([y[i][0], y[i][1], y[i][3], y[i][2]]);
					values_close.push(y[i][1]);
					values_close_last.push((y[y.length - 1][1]));
					values_turnover.push(turnover[i] != null ? turnover[i] : '-')
					values_preclose.push((y[i].length > 4 && y[i][4] != null) ? y[i][4] : (i > 0 ? y[i-1][1] : y[i][1]))
					if(this.symbol_code.startsWith("30")){
						values_next_uplimit.push(new Number((y[y.length - 1][1]) * 1.2).toFixed(2));
					}else{
						values_next_uplimit.push(new Number((y[y.length - 1][1]) * 1.1).toFixed(2));
					}
					
					vols.push([i, vol[i], y[i][0] > y[i][1] ? 1 : -1]);
				}
				return {
					categoryData: categoryData,
					values: values,
					values_close: values_close,
					values_close_last: values_close_last,
					values_next_uplimit: values_next_uplimit,
					values_preclose: values_preclose,
					values_turnover: values_turnover,
					vols: vols,
				};
			},
            handleChartClick(params) {
                // 扩大点击响应区域，只要有日期信息就触发事件
                if (params.name) {
                    // 获取点击的日期
                    const clickedDate = params.name;
                    // 发送事件到父组件
                    this.$emit('date-selected', clickedDate);
                    this.internalHighlightDate = clickedDate;
                    this.refresh();
                }
            },
			computeMarkerY(data, index) {
				return data.values[index][3];
			},
			moveHighlight(delta){
				const data = this._klineSplit && this._klineSplit.categoryData ? this._klineSplit.categoryData : [];
				if(!data || data.length===0) return;
				const eff = this.internalHighlightDate || this.highlightDate || data[data.length-1];
				const effRaw = typeof eff==='string' ? eff.replace(/-/g,'') : '';
				let idx = data.indexOf(effRaw);
				if(idx===-1){ idx = delta<0 ? data.length-1 : 0 }
				let newIdx = idx + delta;
				if(newIdx < 0) newIdx = 0;
				if(newIdx > data.length-1) newIdx = data.length-1;
				this.internalHighlightDate = data[newIdx];
				this.$emit('date-selected', this.internalHighlightDate);
				this.refresh();
			},
            updateHighlight() {
                this.internalHighlightDate = this.highlightDate || null;
                this.refresh();
            },
			
			// 检测是否满足B点标记条件
			checkBPointCondition(data, index) {
				// 如果索引太小，无法计算所需的历史数据，则返回false
				if (index < 13) {
					return false;
				}
				
				// 获取最近3天的收盘价和25日均线数据
				const closeValues = data.values_close.slice(index - 2, index + 1);
				const ma25Values = this.calculateMA(25, data).slice(index - 2, index + 1);
				
				// 获取最近3天的5日均量线和60日均量线数据
				const volMA5Values = this.calculateVolumeMA(5, data).slice(index - 2, index + 1);
				const volMA60Values = this.calculateVolumeMA(60, data).slice(index - 2, index + 1);
				
				// 获取3天前的10个交易日的5日均量线和60日均量线数据
				const prevVolMA5Values = this.calculateVolumeMA(5, data).slice(index - 13, index - 3);
				const prevVolMA60Values = this.calculateVolumeMA(60, data).slice(index - 13, index - 3);
				
				// 条件1：最近3天的收盘价都超过25日均线
				const condition1 = closeValues.every((close, i) => {
					return close > ma25Values[i] && ma25Values[i] !== '-';
				});
				
				// 条件2：最近3天的5日均量线都超过60日均量线
				const condition2 = volMA5Values.every((vol5, i) => {
					return vol5 !== '-' && volMA60Values[i] !== '-' && vol5 > volMA60Values[i];
				});
				
				// 条件3：3天前的10个交易日中有7个以上5日均量线低于60日均量线
				const lowerCount = prevVolMA5Values.filter((vol5, i) => {
					return vol5 !== '-' && prevVolMA60Values[i] !== '-' && vol5 < prevVolMA60Values[i];
				}).length;
				const condition3 = lowerCount >= 7;
				
				// 所有条件都满足时返回true
				// console.log('B点条件检查:', { 
				// 	index: index, 
				// 	condition1, 
				// 	condition2, 
				// 	condition3, 
				// 	lowerCount,
				// 	result: condition1 && condition2 && condition3 
				// });
				return condition1 && condition2 && condition3;
			},
			
			// 检测是否满足B2点标记条件
			checkB2PointCondition(data, index) {
				// 收盘价逐步接近25日均价线(用3日均价线计算），同时5日均量线逐步接近60日均价线，某一天成交量放大且5日均量线高于60日均量线，当天对应涨幅也大涨5%以上
				// 如果索引太小，无法计算所需的历史数据，则返回false
				if (index < 13) {
					return false;
				}
				
				// 获取当天和前几天的数据
				const days = 6
				const ma5Values = this.calculateMA(5, data).slice(index - days, index + 1); // 获取最近10天的5日均线
				const ma25Values = this.calculateMA(25, data).slice(index - days, index + 1); // 获取最近20天的25日均线
				const volMA5Values = this.calculateVolumeMA(5, data).slice(index - days, index + 1); // 获取最近20天的5日均量线
				const volMA60Values = this.calculateVolumeMA(60, data).slice(index - days, index + 1); // 获取最近20天的60日均量线
				
				// 获取当天的成交量和前一天的成交量
				const currentVol = data.vols[index][1];
				const prevVol = data.vols[index - 1][1];
				
				// 获取当天和前一天的收盘价，计算涨幅
				const currentClose = data.values[index][1]; // 当天收盘价
				const prevClose = data.values[index - 1][1]; // 前一天收盘价
				const priceIncrease = (currentClose - prevClose) / prevClose * 100; // 涨幅百分比
				
				// 条件1：3日均价线逐步接近25日均线（最近5天3日均价线与25日均线的差距逐渐减小）
				let ma5ToMA25 = true;
				
				// 判断5日均价线是否逐步接近25日均线
				for (let i = 1; i < ma5Values.length - 2; i++) {
					if (ma5Values[i] === '-' || ma5Values[i-1] === '-' || ma25Values[i] === '-' || ma25Values[i-1] === '-') {
						continue;
					}
					const pct_ma5_reduce = (ma5Values[i] / ma5Values[i-1] - 1) * 100
					let not_reduce = 0
					if (ma5Values[i] > ma5Values[i-1] || ma5Values[i] < ma25Values[i]) {
						// console.log(pct_ma5_reduce)
						if (0 < pct_ma5_reduce < 10) {
							not_reduce += 1
							if (not_reduce > 1){
								ma5ToMA25 = false;
							break;
							}
							continue
						}
						ma5ToMA25 = false;
						break;
					}
				}
				
				// 条件2：5日均量线逐步接近60日均量线
				let vol5ClosingToVol60 = true;
				for (let i = 1; i < volMA5Values.length - 2; i++) {
					const pct_ma5_ma60 = (volMA5Values[i] / volMA60Values[i] - 1) * 100
					if (volMA5Values[i] > volMA5Values[i-1] || pct_ma5_ma60 < -8) {
						vol5ClosingToVol60 = false;
						break;
					}
				}
				
				// 条件3：当天成交量放大（比前一天增加至少30%）
				const volumeIncrease = currentVol > prevVol * 1.3;
				
				// 条件4：5日均量线高于60日均量线
				const pct_ma5_ma60_v = (volMA5Values[volMA5Values.length - 1] / volMA60Values[volMA60Values.length - 1] - 1) * 100
				const vol5AboveVol60 =  pct_ma5_ma60_v > - 8
				// console.log('pct_ma5_ma60_v:', pct_ma5_ma60_v)
				// 条件5：当天涨幅大于5%
				const highIncrease = priceIncrease > 2;
				
				// 所有条件都满足时返回true
				// console.log('B2点条件检查:', { 
				// 	date: data.categoryData[index],
				// 	index: index, 
				// 	ma5ToMA25, 
				// 	vol5ClosingToVol60, 
				// 	volumeIncrease, 
				// 	vol5AboveVol60,
				// 	highIncrease,
				// 	priceIncrease,
				// 	result: ma5ToMA25 && vol5ClosingToVol60 && volumeIncrease && vol5AboveVol60 && highIncrease
				// });
				
				return ma5ToMA25 && vol5ClosingToVol60 && volumeIncrease && vol5AboveVol60 && highIncrease;
			},
			
			// 检测是否满足B3点标记条件
			checkB3PointCondition(data, index) {
				// B3点条件：
				// 1. 往前第3-13个交易日收盘价在25日均价线之上
				// 2. 往前第2个交易日收盘价在25日均价线之下
				// 3. 往前第1个交易日收盘价在25日均线之上
				// 4. 往前第2-4个交易日的成交量均量低于往前第5-15个交易日的3日成交均量线的最低点
				// 5. 往前第2-4个交易日的5日均量线都低于60日均量线
				
				// 如果索引太小，无法计算所需的历史数据，则返回false
				if (index < 15) {
					return false;
				}
				
				// 获取收盘价数据
				const closeValues = [];
				for (let i = index - 13; i <= index; i++) {
					if (i >= 0 && i < data.values.length) {
						closeValues.push(data.values[i][1]); // 收盘价
					}
				}
				
				// 获取25日均线数据
				const ma25Values = this.calculateMA(25, data).slice(index - 13, index + 1);
				
				// 获取成交量数据
				const volumeValues = [];
				for (let i = index - 15; i <= index; i++) {
					if (i >= 0 && i < data.vols.length) {
						volumeValues.push(data.vols[i][1]); // 成交量
					}
				}
				
				// 获取5日均量线和60日均量线数据
				const volMA5Values = this.calculateVolumeMA(5, data).slice(index - 4, index + 1);
				const volMA60Values = this.calculateVolumeMA(60, data).slice(index - 4, index + 1);
				
				// 条件1：往前第3-13个交易日收盘价在25日均价线之上
				let condition1 = true;
				for (let i = 3; i <= 13; i++) {
					const idx = closeValues.length - i;
					if (idx < 0 || ma25Values[idx] === '-') {
						continue;
					}
					if (closeValues[idx] <= ma25Values[idx]) {
						condition1 = false;
						break;
					}
				}
				
				// 条件2：往前第2个交易日收盘价在25日均价线之下
				const idx2 = closeValues.length - 2;
				const condition2 = idx2 >= 0 && ma25Values[idx2] !== '-' &&  closeValues[idx2] < ma25Values[idx2];
				
				// 条件3：往前第1个交易日收盘价在25日均线之上
				const idx1 = closeValues.length - 1;
				const condition3 = idx1 >= 0 &&  ma25Values[idx1] !== '-' &&  closeValues[idx1] > ma25Values[idx1];
				
				// 计算往前第5-15个交易日的3日成交均量线
				const vol3MAValues = [];
				for (let i = 2; i < volumeValues.length - 4; i++) {
					if (i >= 2) {
						const vol3MA = (volumeValues[i] + volumeValues[i-1] + volumeValues[i-2]) / 3;
						vol3MAValues.push(vol3MA);
					}
				}
				
				// 找出往前第5-15个交易日的3日成交均量线的最低点
				let minVol3MA = Number.MAX_VALUE;
				for (let i = 0; i < vol3MAValues.length; i++) {
					if (vol3MAValues[i] < minVol3MA) {
						minVol3MA = vol3MAValues[i];
					}
				}
				
				// 条件4：往前第2-4个交易日的成交量均量低于最低点
				let condition4 = true;
				for (let i = 2; i <= 4; i++) {
					const idx = volumeValues.length - i;
					if (idx < 0) {
						continue;
					}
					if (volumeValues[idx] >= minVol3MA) {
						condition4 = false;
						break;
					}
				}
				
				// 条件5：往前第2-4个交易日的5日均量线都低于60日均量线
				let condition5 = true;
				for (let i = 0; i < 3; i++) {
					if (volMA5Values[i] === '-' || volMA60Values[i] === '-') {
						continue;
					}
					if (volMA5Values[i] >= volMA60Values[i]) {
						condition5 = false;
						break;
					}
				}
				
				// 所有条件都满足时返回true
				// console.log('B3点条件检查:', { 
				// 	index: index, 
				// 	condition1, 
				// 	condition2, 
				// 	condition3, 
				// 	condition4, 
				// 	condition5,
				// 	result: condition1 && condition2 && condition3 && condition4 && condition5
				// });
				
				return condition1 && condition2 && condition3 && condition4 && condition5;
			},
		}
	}
</script>

<style>
.chart_stock_kline_popular {
	width: 100%;
	height: 600px;
}
</style>
